var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("EIE Investments")]),_vm._v(" "),(_vm.eieInvestments)?_c('EieInvestmentsTable',{attrs:{"eie-investments":_vm.eieInvestments,"loading":_vm.loading,"cancel-investment":_vm.cancelInvestment}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bd6075c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/eie/EieInvestments.vue
// module id = null
// module chunks = 